import { render, staticRenderFns } from "./OurNextPreviousNavigator.vue?vue&type=template&id=5bffc62c&"
import script from "./OurNextPreviousNavigator.vue?vue&type=script&lang=js&"
export * from "./OurNextPreviousNavigator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports